// extracted by mini-css-extract-plugin
module.exports = {"contentLang":"LanguageItems_contentLang__20hga","active":"LanguageItems_active__2i2Or"};